export default __webpack_public_path__ + "static/bg-758d523f6b3409e21b46a88c8d092af4.jpg";